import { TableCell, withStyles } from '@material-ui/core';
import styles from './PaginatedTableCell.styles';

export default withStyles(styles, {
    name: 'PaginatedTableCell',
  })(TableCell);
